import React, { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import CLocalizedTextString from '../../components/CLocalizedTextString';
import { PageRoutes } from '../../enums/enums';
import { useAppDispatch } from '../../hooks/hooks';
import { addBreadcrumbTextReplacement, purgeBreadcrumbTextReplacementDictForOutlets } from '../../store/appSlice';

export default function PDownloadCenterOutlet() {
  const dispatch = useAppDispatch();
  const downloadCenterTitle = CLocalizedTextString('downloadCenter.title');
  useEffect(() => {
    dispatch(addBreadcrumbTextReplacement([PageRoutes.DOWNLOAD_CENTER_OUTLET, downloadCenterTitle]));

    return () => {
      dispatch(purgeBreadcrumbTextReplacementDictForOutlets());
    };
  }, [dispatch, downloadCenterTitle]);
  return <Outlet />;
}